import { Dropdown, DropdownItem, IconMoon, IconSun, } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import darkMode from '~/portal/images/modes/dark-mode.svg'
import lightMode from '~/portal/images/modes/light-mode.svg'
import systemMode from '~/portal/images/modes/system-mode.svg'
import { MODE } from '~/shared/components/DarkMode/constants'
import { useDarkMode } from '~/shared/components/DarkMode/hook'

export const DarkModeToggleLoggedOut = () => {

  const { t } = useTranslation()

  const { setMode, isDark } = useDarkMode()

  const ModeItem = ({ image, text, className = '' }) => (
    <span className={clsx('flex pt-[6px] w-52 items-center', className)}>
      <img src={image} alt={text} />
      <span className="ml-4">{text}</span>
    </span>
  )

  const modeToggleItems: DropdownItem[] = [{
    name: MODE.LIGHT,
    content: <ModeItem image={lightMode} text={t('components.ui.modeToggle.light')} />,
  }, {
    name: MODE.DARK,
    content: <ModeItem image={darkMode} text={t('components.ui.modeToggle.dark')} />,
  },
  {
    name: MODE.SYSTEM,
    content: <ModeItem image={systemMode} text={t('components.ui.modeToggle.system')} className="pb-[6px]" />,
  }
  ]

  const toggleDarkMode = (mode: string) => setMode(mode as MODE)

  return (
    <Dropdown
      menuItems={modeToggleItems}
      onClick={toggleDarkMode}
      dropdownButton={<span className="flex items-center py-3 text-(--sp-color-text-strong)">
        {isDark() ? <IconMoon /> : <IconSun />}
        <span className="ml-1">{t('components.ui.modeToggle.label')}</span>
      </span>}
      ariaLabel={t('components.ui.modeToggle.ariaLabel')}
      className="sp-mode-toggle h-10 px-4 w-28 min-w-28"
      panelClassName="sp-mode-toggle-panel"
      itemClassName="sp-mode-toggle-item"
    />
  )
}